const {
  Menu,
  Submenu,
  MenuItem,
  Row,
  Col,
  Table,
  TableColumn,
  Form,
  FormItem,
  Pagination,
  Message,
  MessageBox,
  Select,
  Option,
  Radio,
  RadioGroup,
  Tooltip,
  DatePicker,
  Loading,
  Button,
  Upload,
  CheckboxGroup,
  Checkbox,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Image,
  Input,
  Dialog,
  Notification,
  Descriptions,
  DescriptionsItem,
  Tag,
  Switch,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Slider,
  Timeline,
  TimelineItem,
  Drawer,
  Empty 
} = require('element-ui');
module.exports = {
  install(Vue) {
    Vue.use(Drawer);
    Vue.use(TimelineItem);
    Vue.use(Timeline);
    Vue.use(Switch);
    Vue.use(Card);
    Vue.use(Slider);
    Vue.use(Descriptions);
    Vue.use(DescriptionsItem);
    Vue.use(Menu);
    Vue.use(Submenu);
    Vue.use(MenuItem);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Pagination);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Radio);
    Vue.use(Tooltip);
    Vue.use(DatePicker);
    Vue.use(Button);
    Vue.use(Upload);
    Vue.use(CheckboxGroup);
    Vue.use(Checkbox);
    Vue.use(Dropdown);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    Vue.use(Image);
    Vue.use(Input);
    Vue.use(RadioGroup);
    Vue.use(Tag);
    Vue.use(Dialog);
    Vue.use(Breadcrumb);
    Vue.use(BreadcrumbItem);
    Vue.use(Empty);
    Vue.use(Loading);
    Vue.prototype.$message = Message;
    Vue.prototype.$loading = Loading;
    Vue.prototype.$messageBox = MessageBox;
    Vue.prototype.$notification = Notification;
  },
};
